module.exports = __webpack_public_path__ + "static/media/background_1x.c0b63e45.jpg";